export default "__VITE_ASSET__DSjyhmbs__"